// Need to use the React-specific entry point to import createApi
import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { dispatcherUrl } from "Src/const";
import { getFormData } from "../utils";
import { IStructModels, ISettings } from "Src/Models";
import { getUnpackedSettings } from "http2";

export const structureApi = createApi({
  reducerPath: "structureApi",
  baseQuery: fetchBaseQuery({ baseUrl: dispatcherUrl }),
  endpoints: (builder) => ({
    getModels: builder.mutation<Record<string, IStructModels>, string>({
      query: (licenseKey) => {
        return {
          url: "/models",
          method: "post",
          formData: true,
          body: getFormData([["SERVER_KEY", licenseKey]]),
        };
      },
    }),
    getSettings: builder.mutation<ISettings, string>({
      query: (licenseKey) => {
        return {
          url: "/settings",
          method: "post",
          formData: true,
          body: getFormData([["SERVER_KEY", licenseKey]]),
        };
      },
    }),
  }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const { useGetModelsMutation, useGetSettingsMutation } = structureApi;
